import type { FaireThemeEntity } from "../../entity_types/theme";

export const first_step_leather_moccs: FaireThemeEntity = {
  token: "first-step-leather-moccs",
  type: "theme",
  name: "First-Step Leather Moccs",
  description: "",
  teaser: "",
  detail: "",
  bgColor: "#F5D6D6",
  exactProducts: true,
  retailerToken: "r_eer7xgiweo",
  productTokens: [
    "p_d7v3xth2",
    "p_3b2u8mb5bk",
    "p_d7ynwmtw",
    "p_8eqpgrj87h",
    "p_3j6pbw6guv",
    "p_8kp2u3q5vh",
    "p_57zffppe2w",
    "p_zrdwx37ysx",
    "p_vtrwg49k5f",
    "p_b3qgq97rfs",
    "p_xch6k5scn3",
    "p_a953k23cu7",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
